// extracted by mini-css-extract-plugin
export var root = "TabularImageGrid-module--root--bda80";